import Analytics from '@withlocals/withlocals-analytics';
import Carousel from 'components/Carousel';
import { ExperienceSource } from 'model/IExperience';
import React, { memo } from 'react';
import { Trek } from 'utils/analytics';

import { WlWindow } from '../../../../../typings/globals/cordova';
import TopSearchCard from './TopSearchCard';

declare const window: WlWindow;

const CSS = require('./TopSearchesList.less');

interface TopSearchesListProps {
  experiences: ExperienceSource[];
  nrOfAdults: number;
  nrOfChildren: number;
  useAdvertisedPrice?: boolean;
}

function onSliderButton(direction: 'next' | 'previous') {
  Analytics.track(
    `Top slider ${window.currentPageCategory}`,
    'Click',
    direction === 'next' ? 'Right arrow' : 'Left arrow',
  );
}

function TopSearchesList({
  experiences,
  nrOfAdults,
  nrOfChildren,
  useAdvertisedPrice,
}: TopSearchesListProps) {
  if (experiences.length === 0) {
    return null;
  }

  return (
    <Carousel className={CSS.Carousel} onSideButton={onSliderButton}>
      {experiences.map((experience, index) =>
        !experience ? null : (
          <Trek
            key={experience.id}
            context={{ position: index, section: ['top-search-list'] }}
          >
            <li className={CSS.CarouselItem} key={experience.id}>
              <TopSearchCard
                experience={experience}
                position={index + 1}
                nrOfAdults={nrOfAdults}
                nrOfChildren={nrOfChildren}
                useAdvertisedPrice={useAdvertisedPrice}
                analyticsListName="TopSearchList"
              />
            </li>
          </Trek>
        ),
      )}
    </Carousel>
  );
}

export default memo(TopSearchesList);
